import { render, staticRenderFns } from "./TeachersInCanton.vue?vue&type=template&id=4476d6a2&scoped=true"
import script from "./TeachersInCanton.vue?vue&type=script&lang=js"
export * from "./TeachersInCanton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476d6a2",
  null
  
)

export default component.exports